module.exports = __webpack_public_path__ + "img/bear-pink.330b4530.svg";